import React from 'react';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { TableCell, TableRow, Checkbox, Link, Tooltip } from '@mui/material';
import { ThemedTypography } from 'components/common/CommonStyles';
import PropTypes from 'prop-types';

export const FinancedOffersAssetItemComponent = ({
  t,
  asset,
  offerId,
  offerSiteId,
  openOfferAsset,
  selectAssetsForContractGeneration,
  selected
}) => {
  return (
    <TableRow key={asset.id}>
      <TableCell>
        <Checkbox
          checked={selected}
          onChange={selectAssetsForContractGeneration(offerId, offerSiteId, asset.id)}
          disabled={asset.contractNumber ? true : asset.canGenerateContract === true ? false : true}
        />
      </TableCell>
      <Tooltip title={asset.quantity + ' X ' + asset.name}>
        <TableCell>
          <Link component='button' onClick={openOfferAsset(offerId, offerSiteId, asset.id)}>
            <ThemedTypography color='info'>
              {asset.quantity} X {asset.name}
            </ThemedTypography>
          </Link>
        </TableCell>
      </Tooltip>
      <TableCell>
        <Link component='button' onClick={openOfferAsset(offerId, offerSiteId, asset.id)}>
          <ThemedTypography color='info'>{asset.chassisNumber}</ThemedTypography>
        </Link>
      </TableCell>
      <TableCell>
        <ThemedTypography color='info' weight='bold'>{`${t('NUMBER', { number: asset.totalValue })} ${asset.currency}`}</ThemedTypography>
      </TableCell>
      <TableCell>
        <ThemedTypography color='info'>{asset.dealerName}</ThemedTypography>
      </TableCell>
      <TableCell>
        <ThemedTypography color='info'>{asset.contractNumber}</ThemedTypography>
      </TableCell>
    </TableRow>
  );
};

FinancedOffersAssetItemComponent.propTypes = {
  asset: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  offerId: PropTypes.number.isRequired,
  offerSiteId: PropTypes.number.isRequired,
  openOfferAsset: PropTypes.func.isRequired,
  selectAssetsForContractGeneration: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired
};

export default compose(withTranslation())(FinancedOffersAssetItemComponent);
